import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MailStateService } from '../../services/mail-state.service';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.css']
})
export class MailComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private mailStateService: MailStateService,

  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['condition']) {
        this.mailStateService.condition = params['condition'];
        this.router.navigate(['mail/login']);
      }
      if (this.router.url === '/mail' && !params['condition']) {
        this.router.navigate(['']);
      }
    });
  }

  ngOnInit() {
  }
}
